export default "__VITE_ASSET__CviO1RhX__"